const INIT_STATE = {
  loading: false,
  error: false,
  errorMessage: null,
	list: [],
	item: null,
	action: null
};

const reducer = (state = INIT_STATE, action)=>{
	switch (action.type) {
		case 'GET_MEASURES':
			return { ...state, loading: true, error: false, errorMessage: null, action: null, list: [] };

		case 'GET_MEASURES_SUCCESS':
			return { ...state, loading: false, error: false, errorMessage: null, list: action.payload.data, action: null };

		case 'GET_MEASURES_FAILED':
			return { ...state, loading: false, error: true, errorMessage: action.payload.message, action: null };

		case 'GET_MEASURE':
			return { ...state, loading: true, error: false, action: null };

		case 'GET_MEASURE_SUCCESS':
			return { ...state, loading: false, error: false, item: action.payload.data, action: null };

		case 'GET_MEASURE_FAILED':
			return { ...state, loading: false, error: true, errorMessage: action.payload.message, action: null };

		case 'CREATE_MEASURE':
			return { ...state, loading: true, error: false, action: null }

		case 'CREATE_MEASURE_SUCCESS':
			return { ...state, loading: false, error: false, action: 'CREATED' }

		case 'CREATE_MEASURE_FAILED':
			return { ...state, loading: false, error: true, errorMessage: action.payload.message, action: null }

		case 'UPDATE_MEASURE':
			return { ...state, loading: true, error: false, action: null }

		case 'UPDATE_MEASURE_SUCCESS':
			return { ...state, loading: false, error: false, action: 'UPDATED' }

		case 'UPDATE_MEASURE_FAILED':
			return { ...state, loading: false, error: true, errorMessage: action.payload.message, action: null }

		case 'DELETE_MEASURE':
			return { ...state, loading: true, action: null }

		case 'DELETE_MEASURE_SUCCESS':
			return { ...state, loading: false, error: false, action: 'DELETED' }

		case 'DELETE_MEASURE_FAILED':
			return { ...state, loading: false, error: true, errorMessage: action.payload.message, action: null }

		default:
			return state;
	}
};

export default reducer;